import { CuteIcon } from '@/shared/components/CuteIcon'
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import type { HealthAccent } from './HealthIcon'



export interface HealthValue {
  amount: string
  unit: string
}

export interface HealthCardProps {
  title: string
  value: HealthValue | null
  supportingText: string
  href: string
  accent: HealthAccent
  change?: ReactNode
  detail?: ReactNode
}

export function HealthCard({ title, value, supportingText, href, accent, change, detail }: HealthCardProps) {
  return (
    <article className={`health-card health-card--${accent}`}>
      <div className="health-card__header">
        <span className="health-card__icon" aria-hidden="true">
          <CuteIcon name={accent} size={34} />
        </span>
        <h2>{title}</h2>
      </div>
      <div className="health-card__value-row"><p
        className={`health-card__value${value === null ? ' health-card__value--empty' : ''}`}
        aria-label={value === null ? '暂无数据' : `${value.amount} ${value.unit}`.trim()}
      >
        {value === null ? (
          '—'
        ) : (
          <>
            <span>{value.amount}</span>
            <span className="health-card__unit">{value.unit}</span>
          </>
        )}
      </p>
      {change}</div>
      <p className="health-card__supporting">{supportingText}</p>
      {detail}
      <div className="health-card__actions">
        {value === null ? (
          <Link aria-label={`记录${title}`} to={`${href}/new`}>＋记录</Link>
        ) : null}
        <Link aria-label={`查看${title}详情`} to={href}>
          <span aria-hidden="true">↗</span>
        </Link>
      </div>
    </article>
  )
}
